import React, { useState, useEffect } from "react";

import { styled, Radio, Checkbox } from "@mui/material";

const StyledCheckbox = styled(Checkbox)(({ theme }) => ({
  // display: "none",
  //   opacity: "0",
  color: "white",
  padding: "0",
  "&.Mui-checked": {
    color: "#343759",
  },
  "&.MuiRadio-root": {
    padding: "0",
  },
  // "&.MuiRadio-colorPrimary": {
  //   color: "white",
  // },
  // "&.MuiRadio-colorPrimary.Mui-checked": {
  //   color: "#FFCD1F",
  // },
  // "&.MuiRadio-colorPrimary.Mui-checked:hover": {
  //   backgroundColor: "transparent",
  // },
  // "&.MuiRadio-colorPrimary.Mui-checked:focus": {
  //   backgroundColor: "transparent",
  // },

  // "&.MuiRadio-colorPrimary.Mui-checked:focus:hover": {
  //   backgroundColor: "transparent",
  // },
  // "&.MuiRadio-colorPrimary.Mui-checked:focus-visible": {
  //   backgroundColor: "transparent",
  // },

  // "&.MuiRadio-colorPrimary.Mui-checked:focus-visible:hover": {
  //   backgroundColor: "transparent",
  // },
}));

const CheckBox = ({ multipleSelect, selectall, data }) => {
  const [check, setCheck] = useState(false);
  useEffect(() => {
    if (selectall) {
      setCheck(true);
      multipleSelect.current.set(data?.id, data?.title);
    } else {
      setCheck(false);
    }
  }, [selectall]);

  useEffect(() => {
    if (multipleSelect.current && multipleSelect.current.has(data.id)) {
      setCheck(true);
    } else {
      setCheck(false);
    }
  }, []);

  return (
    <>
      <input
        type="checkbox"
        className="siteCheckBox"
        checked={check}
        onChange={(e) => {
          if (e.target.checked) {
            multipleSelect.current.set(data?.id, data?.title);
          } else {
            multipleSelect.current.delete(data?.id);
          }
          setCheck(e.target.checked);
        }}
      />
      {/* <StyledCheckbox
        checked={check}
        onChange={(e) => {
          if (e.target.checked) {
            multipleSelect.current.set(data?.id, data?.title);
          } else {
            multipleSelect.current.delete(data?.id);
          }
          setCheck(e.target.checked);
        }}
      /> */}
    </>
  );
};

export default CheckBox;
